import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { createLogger } from 'redux-logger';
import throttle from 'lodash/throttle';

import rootReducer from './_reducers';
import { TabSynchronizationManager } from './TabSynchronizationManager';
import { PersistedStateLoader } from './PersistedStateLoader';
import { CommonStoreSubscriptions } from '../Common/CommonStoreSubscriptions';

let _store = {};
const unsubscribeFns = [];
const throttledFns = [];

export const StoreManager = {
    subscribeFnToStore,
    getStore,
    setStore,
    unsubscribeFromStore,
    setUpStore,
};

function getStore() {
    return _store;
};

function setStore(store) {
    _store = store;
}

function unsubscribeFromStore() {
    throttledFns.forEach(fn => fn.cancel());
    throttledFns.length = 0;
    unsubscribeFns.forEach(unsubscribeFn => unsubscribeFn());
    unsubscribeFns.length = 0;
}

function setUpStore(enableLogger = true) {
    _store = createStore(
        rootReducer,
        PersistedStateLoader.load(),
        applyMiddleware(...getMiddlewares()),
    );
    TabSynchronizationManager.subscribeSynchronizationToStorage(_store);
    CommonStoreSubscriptions.subscribe();
    return _store;

    function getMiddlewares() {
        const middlewares = [thunkMiddleware];
        enableLogger && middlewares.push(createLogger());
        return middlewares;
    }
}

function subscribeFnToStore(subscriptionFn = getState => {}) {
    const throttled = throttle(() => subscriptionFn(_store.getState), 1000);
    throttledFns.push(throttled);
    unsubscribeFns.push(
        _store.subscribe(throttled)
    );
}